export function configurableEntityTabKeys({
    metadataMode,
    metadataEntitiesEnabled,
    canManageCustomMetaFields,
    canManageMetadataEntityTypes,
    canManageCustomMetaGroups,
    canManageMetadataEntityImports
}) {
    if (!metadataMode) return ["text-asset-types", canManageCustomMetaGroups && "field-groups", "text-asset-imports"].filter(Boolean);

    return [
        metadataEntitiesEnabled && canManageMetadataEntityTypes && "metadata-entities",
        metadataEntitiesEnabled && canManageCustomMetaFields && "metadata-entity-fields",
        metadataEntitiesEnabled && canManageMetadataEntityImports && "metadata-entity-imports"
    ].filter(Boolean);
}

export function configurableEntityLoadPlan({
    metadataMode,
    metadataEntitiesEnabled,
    canManageMetadataEntityTypes,
    canManageCustomMetaFields,
    canManageCustomMetaGroups,
    canManageMetadataEntityImports
}) {
    if (!metadataMode) {
        return {
            entityTypes: true,
            metadataEntityTypes: false,
            groups: canManageCustomMetaGroups,
            assetImports: true,
            metadataEntityImports: false,
            schemaFields: true,
            conversionFields: false
        };
    }

    return {
        entityTypes: false,
        metadataEntityTypes: metadataEntitiesEnabled && (canManageMetadataEntityTypes || canManageMetadataEntityImports),
        groups: metadataEntitiesEnabled && (canManageMetadataEntityTypes || canManageCustomMetaGroups),
        assetImports: false,
        metadataEntityImports: metadataEntitiesEnabled && canManageMetadataEntityImports,
        schemaFields: metadataEntitiesEnabled && (canManageMetadataEntityTypes || canManageCustomMetaFields),
        conversionFields: metadataEntitiesEnabled && canManageMetadataEntityTypes
    };
}

export function configurableEntityPickerFields({assetFields, conversionFields, metadataMode, editing, entityTypes}) {
    const assetBackedGroup = editing?.kind === "group" && (editing.record?.asset_entity_type_used ||
        entityTypes.some(type => (type.custom_meta_groups || []).some(membership => membership.custom_meta_group?.id === editing.record?.id)));
    const fields = assetBackedGroup ? [...assetFields, ...conversionFields].filter(field => field.owner_type === "Asset")
        : metadataMode ? [...assetFields, ...conversionFields] : assetFields;
    return fields.filter((field, index) => fields.findIndex(candidate => candidate.id === field.id) === index);
}
